import React from "react";
import styles from "./Switch.module.scss";

const Switch = ({toggleSwitch, twoDActive, threeDActive}) => {

    return (
        <div className={styles.switchContainer}>
            <div id={styles.twoDButton} className={twoDActive ? styles.btnActive : styles.btnInactive} onClick={toggleSwitch}>2D</div>
            <div id={styles.threeDButton} className={threeDActive ? styles.btnActive : styles.btnInactive} onClick={toggleSwitch}>3D</div>
        </div>
    )
}

export { Switch };